import React from 'react';

import classnames from 'classnames';
import { useIntl } from 'react-intl';

import PropTypes from 'prop-types';
import {
  Label,
  Input,
} from 'reactstrap';

import HelpIcon from '../HelpIcon';
import UpgradePlanButton from '../UpgradePlanButton';

import { canUserManageShare } from '../../helpers/Share';

const ShareModalRequireAcceptDocument = ({
  handleChange,
  requireAcceptDocument,
}) => {
  const intl = useIntl();

  return (
    <div className="share-select-require-email share-setting">
      <Label for="inpSelectRequireAcceptDocument" className={classnames('switch', { disabled: !canUserManageShare() })}>
        <span>
          {intl.formatMessage({ defaultMessage: 'Require document acceptance' })}
          <HelpIcon id="share-require-accept-document">
            {intl.formatMessage({ defaultMessage: 'Require recipients to accept the document before accessing this share link.' })}
          </HelpIcon>
        </span>
        <div className="share-setting-switch-wrapper">
          <UpgradePlanButton feature="share-require-accept-document" simple={true} />
          <div className="switch-control input-inner">
            <Input
              type="checkbox"
              name="select-require-accept-document"
              id="inpSelectRequireAcceptDocument"
              value={true}
              checked={requireAcceptDocument}
              onChange={handleChange}
              disabled={!canUserManageShare()}
            />
            <i />
          </div>
        </div>
      </Label>
    </div>
  );
};

ShareModalRequireAcceptDocument.propTypes = {
  requireAcceptDocument: PropTypes.bool.isRequired,
  handleChange: PropTypes.func.isRequired,
};

export default ShareModalRequireAcceptDocument;
